import { ApiClient } from 'api/RestClient';
import { ContactFormPVO } from 'types/contact/ContactFormPVO';
import { doPost } from 'util/AxiosUtil';

// 문의하기
export const insertContact = async (data: ContactFormPVO) => {
  return doPost(ApiClient, '/api/contact/insertContact', data).then((res) => res.data);
};
